module.exports = __webpack_public_path__ + "img/ACB.3b6d6f39.svg";